import React, { useState, useEffect } from 'react';
import { Box, Alert, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import StatCards from '../components/StatCards';
import Home from '../components/Home';
import { isAuthenticated, apiCall, getUser, logout } from '../services/authService';
 
const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [authError, setAuthError] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyAuthentication = async () => {
      console.log(' [DASHBOARD] Verifying authentication...');
      
      try {
        // Check local authentication
        if (!isAuthenticated()) {
          console.log(' [DASHBOARD] Not authenticated locally');
          navigate('/login');
          return;
        }

        // Get user info
        const user = getUser();
        setUserInfo(user);
        console.log(' [DASHBOARD] User info:', user);

        // Verify token with backend
        const response = await apiCall('/test');
        
        if (!response || !response.ok) {
          throw new Error('Token validation failed');
        }

        console.log(' [DASHBOARD] Authentication verified successfully');
        setIsLoading(false);

      } catch (error) {
        console.error(' [DASHBOARD] Authentication verification failed:', error);
        setAuthError('Authentication failed. Please login again.');
        setIsLoading(false);
        
        // Redirect to login after a short delay
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    };

    verifyAuthentication();
  }, [navigate]);

  const handleToggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = async () => {
    console.log(' [DASHBOARD] Logout initiated from sidebar');
    try {
      await logout('manual');
      // logout function handles redirect
    } catch (error) {
      console.error(' [DASHBOARD] Logout error:', error);
      // Force logout even if API fails
      localStorage.clear();
      navigate('/login');
    }
  };

  // Show loading state
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif'
        }}
      >
        <CircularProgress size={40} sx={{ mb: 2 }} />
        <Box sx={{ color: '#666', fontSize: '16px' }}>
          Loading dashboard...
        </Box>
      </Box>
    );
  }

  // Show error state
  if (authError) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          p: 3
        }}
      >
        <Alert severity="error" sx={{ maxWidth: 400 }}>
          {authError}
        </Alert>
      </Box>
    );
  }
 
  return (
    <>
     <Box
      sx={{
        display: "flex",
        bgcolor: "#ffff",
        minHeight: "100vh",
        fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
     
      }}
    >
      {/* Sidebar */}
      <Sidebar
        collapsed={collapsed}
        onToggleSidebar={() => setCollapsed(!collapsed)}
        onLogout={handleLogout}
      />
 
      {/* Main Content */}
      <Box sx={{
          flex: 1,            //  grow/shrink properly
      minWidth: 0,        //  avoids overflow when sidebar collapses
      display: "flex",
      flexDirection: "column",
      height: "100vh",     //  full height
      overflow: "hidden",  //  no scroll here either
      }}>
        <Header collapsed={collapsed} />
 
        {/* Main content area */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            // p: 3,
            pt: 2,
            mt: "3.1rem", // push below header
            height: { xs: "auto", md: "calc(100vh - 4rem)" },
            overflowY: { xs: "auto", md: "hidden" },
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#fff",
            //  maxWidth: '1500px', //  Add max width constraint
        mx: 'auto', //  Center the content
        width: '100%', //  Full width up to maxWidth
         px: 3, //  Single padding applied here
          }}
        >
          {/* Stat cards at top */}
          {/* <Box sx={{ flexShrink: 0, mx: "auto", width: "100%" }}>
            <StatCards />
          </Box>
          */}
          {/* Home component below */}
          <Box sx={{ mt: 0.5,mx: "auto", width: "100%", flex: 1 }}>
            <Home />
          </Box>
        </Box>
        </Box>
     
      </Box>
    </>
 
  );
};
 
export default Dashboard;
 
 